document.addEventListener("DOMContentLoaded", () => {
  try {
    const _stars_wrapper_el = document.querySelector(
      ".price-inventory-desktop"
    );

    _stars_wrapper_el.addEventListener("click", (evt) => {
      if (evt.target.classList.contains("Stars")) {
        const reviews_el = document.querySelector("#shopify-product-reviews");
        const _tab_wrapper_el = document.querySelector(".product-tabs-wrapper");
        if (reviews_el) {
          if (productReviews.notVisible(reviews_el)) {
            let _reviews_tab_el = reviews_el.closest(
              ".accordion-collapse.collapse"
            ).previousElementSibling.firstElementChild;

            _reviews_tab_el.click();
          }
          setTimeout(() => {
            // productReviews.scrollToElement(reviews_el);
            productReviews.scrollToElement(_tab_wrapper_el);
          }, 200);
        }
      }
    });
  } catch (e) {
    console.log("product reviews error: ", e);
  }
});

const productReviews = {
  scrollToElement(el) {
    el.scrollIntoView({
      behavior: "smooth",
    });
  },
  notVisible(el) {
    try {
      const parent_el = el.closest(".accordion-collapse.collapse");
      return parent_el.classList.contains("show") === false;
    } catch (e) {
      throw new Error("error");
    }
  },
};
